import {
  Component,
  Injector,
  OnInit,
  Pipe,
  PipeTransform,
  HostListener
} from '@angular/core';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { Subscription, interval } from 'rxjs';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { StorageService } from 'src/app/services/storage.service';
import { Utils } from 'src/app/utils/utils';
import { InstallerListObj } from 'src/app/models/common/installer-status.model';
import { ConfirmationDialogService } from 'src/app/modules/confirmation-dialog/confirmation-dialog.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RouteConstants } from 'src/app/constants/route-constants';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  intervalSubscription: any;
  currentPage = 1;
  itemsPerPage = 5;
  isFullscreen: any = false;
  profile_image: any;
  user_details: any = [];
  fullname: any;
  user_email: any;
  timezone: any;
  user_id: any;
  files_id: any;
  installer_list: any;
  searchTerm: string = '';
  isLoading = true;
  inactive_user: boolean = false;
  timezone_list: any = [];
  filterObject = new AdminDashboardUsersPipe();
  previous_data: any;
  apiCallingInstallerList: Map<string,boolean> = new Map()
  private imageSubscription: Subscription | undefined;
  @HostListener('window:resize')
  onResize() {
    const width = window.innerWidth
    this.paginationDataListing(width)

  }
  constructor(
    private auth: AuthserviceService,
    private injector: Injector,
    private router: Router,
    private storage: StorageService,
    private confirmationDialogService: ConfirmationDialogService,
    private commonService: CommonService
  ) {}

  isApiCalling(userId:string):boolean{
    return this.apiCallingInstallerList.has(userId)
  }

  paginationDataListing(width:number){
  
    if(width >= 3700){
      this.itemsPerPage = 10
    }
    else if (width >=2200){
      this.itemsPerPage = 7
    }
    else if(width >=2000){
      this.itemsPerPage = 6
    }
    else{
      this.itemsPerPage = 5
    }
  }

  ngOnInit() {
    this.paginationDataListing(window.innerWidth)
    AppSessionStorageService.sideBarSelection = 1
    this.auth.fetchUserDetails()
    AppSessionStorageService.adminDashboardVerifiedInstallerView = true
    this.resetMemoryVariable();
    this.imageSubscription = this.auth.userProfileDetails$.subscribe(
      (response) => {
        this.userDetails();
      }
    );
    this.getInstallers();
    this.isLoading = false;
    if (!this.profile_image) {
      this.profile_image = 'assets/default-image.svg';
    }
    const secondsCounter = interval(5000);
    if (!this.installer_list) {
      this.isLoading = false;
    }
    this.intervalSubscription = secondsCounter.subscribe((n) => {
      this.getInstallers();
    });
  }

  ngOnDestroy(): void {
    try {
      this.imageSubscription?.unsubscribe();
      this.intervalSubscription?.unsubscribe();
      this.commonService.unSubscribeMqttTopic(AppSessionStorageService.user?.user_id??'')
    } catch (_) {}
  }

  async getInstallers() {
    const installer_list_info = await this.auth.getInstallerList();
    this.verificationInstallerBasedSpliting(installer_list_info);
    if (installer_list_info) {
      for (const installer_info of installer_list_info) {
        if (installer_info) {
          const new_timezone = (installer_info as any)?.timezone;
          if (
            !this.timezone_list.includes(new_timezone) ||
            this.timezone_list.length < 0
          ) {
            this.timezone_list.push(new_timezone);
          }
        }
      }
    }
    let to_lower = true;
    const existing_filter = AppSessionStorageService.sortFilter;
    if (existing_filter) {
      if (existing_filter.includes('tive')) {
        to_lower = false;
      }
    }
    this.installer_list = this.filterObject.transform(
      this.getInstallersList(),
      existing_filter,
      to_lower
    );
    this.serachFilter();
    this.auth.fetchImage(this.installer_list);
  }

  async verificationInstallerBasedSpliting(installers: any) {
    for (const installer of installers) {
      if (installer.verification_status.toLowerCase() === 'true') {
        const existsInVerified =
          AppSessionStorageService.verifiedInstallerList.some(
            (item: { username: any }) => item.username === installer.username
          );
        if (!existsInVerified) {
          AppSessionStorageService.verifiedInstallerList.push(installer);
        }
      } else {
        const existsInUnverified =
          AppSessionStorageService.unVerifiedInstallerList.some(
            (item: { username: any }) => item.username === installer.username
          );
        if (!existsInUnverified) {
          AppSessionStorageService.unVerifiedInstallerList.push(installer);
        }
      }
    }
  }

  onInput() {
    this.search(this.searchTerm);
  }
  getUserImage(image: string) {
    const profileImage = this.auth.getInstallerImages(image);
    if (profileImage) {
      return profileImage;
    }
    return 'assets/default-image.svg';
  }
  getTrimmedFullName(firstName: string, lastName: string): string {
    const fullName = firstName + ' ' + lastName;
    if (fullName.length > 20) {
      // Assuming combined length of both names shouldn't exceed 20 characters
      return fullName.slice(0, 20) + '...';
    } else {
      return fullName;
    }
  }

  search(input: any) {
    this.getInstallersList();
    AppSessionStorageService.searchFilter = this.searchTerm;
    if (input) {
      this.serachFilter();
    }else{
      this.getInstallers();
    }
  }

  serachFilter() {
    this.getInstallersList();
    this.installer_list = this.filterObject.transform(
      this.installer_list,
      AppSessionStorageService.searchFilter,
      true
    );
  }

  timezoneAndStatusFilter(timezoneAndStatusFilter: any, to_lower = true) {
    if (timezoneAndStatusFilter.toLowerCase() == 'all') {
      AppSessionStorageService.sortFilter = '';
      this.installer_list = this.getInstallers();
    } else {
      AppSessionStorageService.sortFilter = timezoneAndStatusFilter;
    }
    this.listsortFilter();
  }

  listsortFilter(to_lower = true) {
    this.installer_list = this.getInstallers();
    this.installer_list = this.filterObject.transform(
      this.installer_list,
      AppSessionStorageService.sortFilter,
      to_lower
    );
  }

  userDetails() {
    const user_details = this.auth.getUserDetails();
    if (user_details) {
      this.fullname = user_details.firstname + ' ' + user_details.lastname;
      this.user_email = user_details.username;
      this.timezone = user_details.timezone;
      this.profile_image = this.auth.getUserImage();
      this.user_id = user_details.user_id;
      this.files_id = user_details.files_id;
    }
  }
  logout() {
    this.auth.logout();
  }

  pageChanged(event: any) {
    this.currentPage = event;
  }

  get paginatedInfo() {
    try {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      if (this.installer_list) {
        return this.installer_list.slice(startIndex, endIndex);
      } else {
        return this.installer_list;
      }
    } catch (_) {
      return []
    }
  }

  async installerView(installer: any) {
    if (installer.Status.toLowerCase() == 'inactive') {
      this.inactiveInstaller();
      return;
    }
    const logger_data = {user_id:installer.user_id,metadata: {operation: "accessed"}}
    const response = await this.auth.adminGrantAccess(installer);
    if (response?.success && response.data) {
      await this.auth.accessLogging(logger_data)
      this.injector
        .get(AppSessionStorageService)
        ?.setGrantToken(response.data, true);
      this.injector
        .get(AppSessionStorageService)
        ?.setInstallerViewUser(installer.user_id);
      this.commonService.subscribeMqttTopic(installer?.user_id ?? '');
      const encryptUserId = this.auth.encryptParams(installer.user_id); // user id encrryption to resolve the issue when user press browser back button
      this.router.navigate([
              RouteConstants.ADMIN_INSTALLER_ROUTES],
        
              { queryParams:{
                  user_id:encryptUserId,
        
               replaceUrl: true }},
            );
    }
    return null;
  }

  inactiveInstaller() {
    this.inactive_user = true;
  }

  popUpClose() {
    this.inactive_user = false;
  }

  getInstallersList() {
    if (AppSessionStorageService.verifiedInstallerList && this.viewSelector()) {
      return AppSessionStorageService.verifiedInstallerList;
    }
    return AppSessionStorageService.unVerifiedInstallerList;
  }

  viewChange(installer_view: boolean) {
    if (installer_view) {
      AppSessionStorageService.adminDashboardVerifiedInstallerView =
        installer_view;
    } else {
      AppSessionStorageService.adminDashboardVerifiedInstallerView =
        installer_view;
    }
    this.installer_list = this.getInstallersList();
    return null;
  }

  viewSelector() {
    if (!AppSessionStorageService.adminDashboardVerifiedInstallerView) {
      return false;
    }
    return true;
  }

  selectedCountry() {
    if (
      AppSessionStorageService.sortFilter &&
      !AppSessionStorageService.sortFilter.includes('tive')
    ) {
      return AppSessionStorageService.sortFilter;
    }
    return 'Country';
  }

  selectedStatus() {
    if (
      AppSessionStorageService?.sortFilter.includes('tive')
    ) {
      return AppSessionStorageService.sortFilter;
    }
    return 'Status';
  }

  resetMemoryVariable() {
    AppSessionStorageService.grantAccess = null;
    AppSessionStorageService.installeView = null;
    AppSessionStorageService.searchFilter = '';
    AppSessionStorageService.sortFilter = '';
  }

  noResult() {
    if (this.installer_list) {
      if (this.installer_list.length > 0) {
        return false;
      }
    }
    return true;
  }

  remove_filter() {
    const filter = AppSessionStorageService.sortFilter;
    if (filter == null) {
      return true;
    }
    AppSessionStorageService.sortFilter = '';
    this.getInstallers();
    return false;
  }

  profile_view(){
    this.router.navigate(['admin/profile']);
  }


  updateList(verificationStatus:string,installer: InstallerListObj) {
    let list: InstallerListObj[] = []

    if(verificationStatus === 'True') {
      list = AppSessionStorageService.unVerifiedInstallerList;
     } else if(verificationStatus==='False') {
     list = AppSessionStorageService.verifiedInstallerList;
     }
     
    const index = list.findIndex(item => item.username === installer.username);

    // If the item is found (index !== -1), remove it
    if (index !== -1) {
      list.splice(index, 1);
    }

  }





  onStatusChange(installer: any, index: number, installerVerifyStatus: string): void {


    if (installer.verification_status === 'True') {

      this.confirmationDialogService.confirm('Updating Installer Status', 'Changing the status of a Verified Installer to Unverified will remove all associated privileges. Please confirm to proceed', 'Proceed',true,true )
      .then((confirmed) => {
        if (confirmed) {
          this.updateStatus(installer, index, installerVerifyStatus)
        }
      })
      .catch(() => {
        // Handle the case when the user cancels or dismisses the dialog
      });
    } else {
      this.updateStatus(installer, index, installerVerifyStatus)
    }
  }





  async updateStatus(installer:any,index:number,installerVerifyStatus?:string){
    if(this.apiCallingInstallerList.has(installer.user_id)){
      return
    }
    this.apiCallingInstallerList.set(installer.user_id,true)
    let status = ""
    let verificationStatus = ""
    await Utils.delay(3000)

    if (!installerVerifyStatus){
    if (installer.Status === 'Active') {
      status = 'Inactive'
    }
    else if (installer.Status === 'Inactive') {
      status = 'Active'
    }
  }
    if (installerVerifyStatus){
      if (installer.verification_status === 'True') {
        verificationStatus = 'False'
      } 
      else if (installer.verification_status === 'False') {
        verificationStatus = 'True'
      } 
  }
    const data = { "user_id": installer.user_id, "status": status, "verification_status": verificationStatus }
    const response = await this.auth.UpdateUserData(data)
    this.apiCallingInstallerList.delete(installer.user_id)
    if(response.success){
      this.updateList(verificationStatus, installer)
      installer.Status = status
      this.getInstallers();
    }
  }
}
@Pipe({
  name: 'AdminDashboardUsers',
})
export class AdminDashboardUsersPipe implements PipeTransform {
  transform(installer_list: any[], searchTerm: string, to_lower = true): any[] {
    if (!installer_list.length || !searchTerm) {
      return installer_list;
    }
    if (to_lower) {
      searchTerm = searchTerm.toLowerCase();
    }

    return installer_list.filter((installer_list) => {
      // Add your filtering logic here
      return (
        installer_list.firstname.toLowerCase().includes(searchTerm) ||
        installer_list.lastname.toLowerCase().includes(searchTerm) ||
        installer_list.username.toLowerCase().includes(searchTerm) ||
        installer_list.timezone.toLowerCase().includes(searchTerm) ||
        installer_list.Status.includes(searchTerm)
        // Add more fields as needed
      );
    });
  }
}
